// 优惠头条工具方法
import dayjs from 'dayjs';

const oneHour = 60 * 60 * 1000;
const oneDay = 24 * oneHour;

/**
 * 显示规则
 * 1. 最近1小时内发布的，显示为“刚刚”；
 * 2. 最近1~23小时内发布的，显示为“x小时前”，”x“取整数，不足1小时，x不加1；
 * 3. 最近24小时~72小时，分别显示为“1天前”、“2天前”、“3天前”；
 * 4. 更久的，显示为“x-y”，即月+日，月和日都需显示为两位数，如1月1日，显示为“01-01”。
 * @param timestamp
 * @returns {string}
 */
export const renderReleaseDate = (timestamp) => {
  const now = dayjs().valueOf();
  const release = dayjs(timestamp * 1000);
  const timeDiff = now - release;

  if (timeDiff < oneHour) return '刚刚';

  if (timeDiff < oneDay) return `${Math.floor(timeDiff / oneHour)}小时前`;

  let n = 2;

  while (n <= 4) {
    if (timeDiff < n * oneDay) {
      return `${n - 1}天前`;
    }

    n += 1;
  }

  return release.format('MM-DD');
};

/**
 * 显示规则
 * 分享/浏览人数 ＜ 10000 时，显示具体数值，分享人数 ＞ 10000 后，显示1w+，
 * 其中每添加 1000 人，显示为 1.1w+，1.2w+.....2w+，直至 10w+...
 * @param n
 * @returns {string}
 */
export const renderCount = (n) => {
  if (n < 10000) {
    return String(n);
  }

  if (n > 100000) {
    return '10w+';
  }

  return `${Number(String(n / 10000).substring(0, 3))}w+`;
};

export const isHot = (tags) => {
  return tags.some(tag => tag.type === 'top' && tag.show);
};

export const isExpire = (tags) => {
  return tags.some(tag => tag.type === 'expire' && tag.show);
};

const textOverflow = (text, length, pad = '...') => {
  if (text.length > length) {
    return `${text.substring(0, length)}${pad}`;
  }
  return text;
};

export const getAuthorName = (name) => {
  return textOverflow(name, 6);
};

export const getHighlight = (highlight) => {
  return textOverflow(highlight, 15);
};
